import {configuratorState} from "../../state";

const FormatMaterialsData = (mainMaterialsMenus, materialSets, devTools) => {
  /*
      ---------------------------------------------------------------------------
      materialSets
  */
  configuratorState.mainMaterialSets = materialSets;

  

  // dev controls - materials
  configuratorState.materialsDeveloperControls = devTools;
  
  /*
   ---------------------------------------------------------------------------
    build materials full main menu structure - for init & defaults
    (currently only used in MaterialsInitialiser)
 */
  // clone data (deep)
  const materialMenusRef = JSON.parse(JSON.stringify(mainMaterialsMenus));
  
  // build menu structure
  materialMenusRef.forEach((item) => {
    
    // delete unwanted
    delete item.modelMaterialRef;
    
    item['menu'].forEach((item) => {
      
      item['menu'] = materialSets[item.title];
      item['menu'].forEach((item) => {
        
        // add link
        item.link = item.title;
        
        // delete unwanted
        delete item['materialProps'];
        delete item['textureSet'];
        
      });
    });
  });
  
  configuratorState.materialMenusRef = materialMenusRef;
  
  /*
    ---------------------------------------------------------------------------
     model parts to materials sets reference map
  */
  const modelToMaterialRef = JSON.parse(JSON.stringify(mainMaterialsMenus));
  
  // build materials structure
  const modelToMaterialRefs = {};
  modelToMaterialRef.forEach((item) => {
    
    modelToMaterialRefs[item.title] = item.modelMaterialRef;
    
  });
  
  configuratorState.modelToMaterialRef = modelToMaterialRefs;

  /*
    ---------------------------------------------------------------------------
      model parts menu
  */
  const modelPartsMenu = {
    selected: '',
    menu: []
  };
  
  mainMaterialsMenus.forEach((item) => {
    
    modelPartsMenu.menu.push({
      // link: item.link,
      title: item.title
    });
    
    if (item.default) {
      modelPartsMenu.selected = item.title;
    }
  });
  
  // get models materials
  const modelMaterials = [];
  mainMaterialsMenus.forEach((item) => {
    modelMaterials.push(item.modelMaterialRef);
  });
  
  
  configuratorState.modelPartsMenu = modelPartsMenu;
  // merge models material ref objs
  configuratorState.modelToMaterialRefList = Object.assign({}, ...modelMaterials);

  
  /*
   ---------------------------------------------------------------------------
     model to group name reference
 */
  const modelToGroupNameRef = {};
  
  mainMaterialsMenus.forEach((item) => {
    
    Object.keys(item.modelMaterialRef).forEach((prop) => {
      modelToGroupNameRef[prop] = item.title;
    });
    
  });
  
  configuratorState.modelToGroupNameRef = modelToGroupNameRef;
  
  /*
    ---------------------------------------------------------------------------
      model materials sets menu
  */
  
  const matMenusRef = JSON.parse(JSON.stringify(mainMaterialsMenus));
  const modelMaterialGroupsMenu = {};
  
  matMenusRef.forEach((item) => {
    
    // delete unwanted
    delete item.default;
    delete item.link;
    
    let currDefault = item.menu.find(menu => menu.default);
    
    // delete unwanted
    delete currDefault.default;
    
    modelMaterialGroupsMenu[item.title] = {
      groupSelected: currDefault.title,
      selectedMaterial: '',
      menu: item.menu
    }
    
  });

  configuratorState.modelMaterialGroupsMenu = modelMaterialGroupsMenu;
  
};

export default FormatMaterialsData;
